import { getContext, hasContext, setContext } from 'svelte';
import { objectEntries, objectFromEntries } from './object-utils';

const CommonTranslationsContextKey = Symbol('CommonTranslationsContextKey');

export const defaultValues = {
  closeText: 'Close',
  readMoreText: 'Read More',
  custom: 'Custom',
  moreStickersFromCategory: 'More stickers from this category',
  showAll: 'Show all',
  addToCart: 'Add to cart',
  width: 'Width',
  height: 'Height',
  buyAsIndividual: 'Buy as individual',
  howTo: 'How to',
  productDetails: 'Product details',
  reviews: 'Reviews',
  viewAll: 'View all',
  login: 'Login',
  signup: 'Sign up',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  changePassword: 'Change Password',
  resetPassword: 'Reset password',
  resetPasswordDescription:
    'Enter your registered email address below and we will send you a password reset link.',
  outOf: 'out of',
  accountProfilePageTitle: 'Account',
  accountProfileSectionTitle: 'Profile',
  billingAndShipping: 'SHIPPING AND BILLING',
  accountAddNew: 'Add new',
  authenticatePaypal: 'Authenticate paypal',
  unlinkPaypal: 'Unlink paypal',
  accountAlternativeShippingAddress: 'ALTERNATIVE SHIPPING ADDRESS',
  accountSubscription: 'SUBSCRIPTION',
  accountNewsletter: 'Newsletter',
  accountNewsletterDescription: 'Keep up with our latest news',
  save: 'Save',
  cancel: 'Cancel',
  business: 'Business',
  billingAddress: 'Billing address',
  firstName: 'First name',
  address1: 'Address 1',
  address2: 'Address 2',
  zipCode: 'Zip code',
  city: 'City',
  phone: 'Phone',
  lastName: 'Last name',
  country: 'Country',
  companyName: 'Company name',
  companyOrgNumber: 'Org. Number',
  companyVatNumber: 'VAT Number',
  account: 'Account',
  orders: 'Orders',
  logout: 'Logout',
  state: 'State',
  send: 'Send',
  shippingAddress: 'Shipping Address',
  nameOrCompany: 'Name or Company',
  attName: 'Att. Name',
  addedToCart: 'Added to cart',
  youHaveAdded: "You've added",
  weAlsoRecommend: 'We also recommend...',
  viewCart: 'View Cart',
  duplicateAndEdit: 'Duplicate and Edit',
  anErrorHasOccured: 'An error has occured',
  quantity: 'Quantity',
  additionalInformation: 'Additional Information',
  sendRequest: 'Send Request',
  requestQuote: 'Request Quote',
  success: 'Success!',
  wellGetBackToYouAsap: 'We will get back to you as soon as possible',
  taxCertificates: 'Tax Certificates',

  passwordStrengthMeter: 'Password strength meter',
  invalidCharacter: 'Invalid character',
  yourPasswordShouldInclude: 'Your password should include:',
  atLeast12Characters: 'At least 12 characters',
  uppercaseAndLowercaseLetters: 'Uppercase and lowercase letters',
  atLeastOneNumber: 'At least one number 0-9',
  atLeastOneSpecialCharacter: 'At least one special character',
  passwordSuccessfullyChanged: 'Password successfully changed',

  drawerMenu: 'Drawer menu',
  mainMenu: 'Main menu',

  navigation: 'Navigation',
  toggleNavigation: 'Toggle navigation',
  goToCheckout: 'Go to checkout',
  visitTrustPilot: 'Visit StickerApp on Trustpilot',

  searchSuggestionOne: 'Sticker Sheets',
  searchSuggestionTwo: 'Labels on Rolls',
  searchSuggestionThree: 'Holographic Sticker',
  searchSuggestionFour: 'Die Cut Sticekrs',
  searchSuggestionFive: 'Sample Pack',
  searchPlaceholder: 'What are you looking for?',
  searchToggle: 'Toggle search bar',
  noResults: 'No results found',
  popularSearches: 'Popular searches',

  stickerAppMagazineHeader: 'STICKERAPP MAGAZINE',
  stickerAppMagazineSubHeader: 'Adhesive Adventures in the World of Stickers',
  quality: 'Quality',
  valueForMoney: 'Value for money',
  moreDetails: 'More details',
  lessDetails: 'Less details',

  continue: 'Continue',
  reorderEmailHelperText: "You'll find it in the email receipt",
  orderNumber: 'Order number',

  moreReviews: 'More reviews',
  supportCategories: 'Support categories',
  articles: 'Articles',
  stickerAppFacebookPage: 'StickerApp Facebook page',
  stickerAppLinkedInPage: 'StickerApp LinkedIn page',
  stickerAppXPage: 'StickerApp X page',
  faq: 'Frequently asked questions',

  author: 'Author',
  loginWithGoogle: 'LOGIN WITH GOOGLE',
  hide: 'Hide',
  stickers: 'Stickers',
  selectTopic: 'Please select a topic',
  statusOfOrder: 'Order status',
  problemWithOrder: 'Problem with order',
  changeCurrentOrder: 'Current order',
  helpPlacingOrder: 'New order',
  collaboration: 'Collaboration',
  sales: 'Sales support',
  other: 'Other',
  requiredField: 'This field is required',
  upload: 'Upload',
  uploadedFiles: 'Uploaded files',
  approvedTaxCertificate: 'Approved Tax Certificate',
  expirationDate: 'Expiration date:',
  taxExemptBusiness:
    'Are you a tax-exempt business? Upload tax-exemption certificate to be verified',
  taxUploadSuccessTitle: 'Thank you for your submission!',
  taxUploadSuccessDescription:
    'Please allow 2 - 3 business days for our team to verify and approve your tax-exemption certificate. Your status will be updated in your account once that has been verified.',
  generalError: 'Something went wrong, please try again',
  next: 'Next',
  previous: 'Previous',
  copyCodeToClipboard: 'Copy code to clipboard',
  copiedToClipboard: 'Copied to clipboard',
  specsTabName: 'Specifications',
  reviewsTabName: 'Reviews',
  siteSelector: 'Region',
  chatInputFieldPlaceholder: 'Ask anything...',
  chatThumbsUp: 'This was helpful',
  chatThumbsDown: 'Not useful',
  openInTab: 'Open in new tab',
  preview: 'Preview',
  edit: 'Edit',
  remove: 'Remove',
  duplicate: 'Duplicate',
  size: 'Size',
  pcs: 'pcs',
  subTotal: 'Subtotal',
  items: 'items',
  shipping: 'Shipping',
  taxes: 'Taxes',
  savings: 'Savings',
  total: 'Total',
  vatIncl: 'VAT incl.',
  vatExcl: 'VAT excl.',
  myCart: 'My cart',
  expressCheckout: 'Express checkout',
  or: 'OR',
  reviewCart: 'Review cart',
  checkoutNow: 'Checkout now',
  addGiftCardOrPromoCode: 'Add gift card / promo code',
  orderSummary: 'Order Summary',
  addedPromoCode: 'Added promo code',
  promoCode: 'Promo code',
  clickToPreview: 'Click to preview',
  orderFromOtherCountryLabel: 'Order from Sweden?',
  orderFromOtherCountryDescription:
    'Get faster delivery, correct payment options and the best customer service.',
  message: 'Message',
  retry: 'Retry',
  checkoutTitle: 'Enter details',
  checkoutAsGuestTitle: 'Checkout as guest',
  selectShipping: 'Select shipping',
  selectPayment: 'Select payment',
  itemsInCart: 'Items in cart',
  placeOrder: 'Place order',
  billingAndShippingSameAdress: 'My billing address is the same as my shipping address',
  streetAddress: 'Street address',
  shippingFormTitle: 'Billing and Shipping address',
  contactDetailsFormTitle: 'Contact details',
  fullName: 'Full name',
  purchasingAsABusiness: 'Purchasing as a business?',
  getItBy: 'Get it by',
  orderId: 'Order id',
  thankYouForYourPurchase: 'Thank you for your purchase!',
  orderProcessingEstimate:
    'Your order will be processed shortly. We will notify you by email once your order has been shipped.',
  shippingTo: 'Shipping to:',
  trackYourOrder: 'Track your order',
  trackDescription: 'To easily track and manage your orders by saving them to your account.',
  addToAccount: 'Add to account',
  shoutOpportunity: 'Shout opportunity!',
  shoutDescription:
    'Take the chance to get your design featured on our social media and digital marketing channels!',
  shoutTerms:
    'Simply tick the box and provide your social media handle so we can give you proper credit and share the love with our community.',
  acceptShout: 'Accept the Shout terms of Use',
  yesPlease: 'Yes please',
  orderDate: 'Order date',
  payment: 'Payment',
  experienceConfirmation: 'How as your experience?',
  quoteMinSheetsError: 'Add designs to send your quote request. Minimum: ',
  chooseYourLocation: 'Choose your location',
  enterYourAddress: 'Enter your address',
  checkoutLoginFormTitle: 'Enter your email address',
  checkoutLoginFormDescription: 'To sign in or to create an account',
  signIn: 'Sign in',
  signInHere: 'Sign in here',
  backToSignIn: 'Back to sign in',
  createAccount: 'Create account',
  haveAnAccount: 'Have an account?',
  checkoutLoginFormCreateAccountTitle: 'Create account',
  checkoutLoginFormCreateAccountDescription: 'Enter your details below',
  notificationErrorTitle: 'This is an error summary',
  forgotPassword: 'Forgot your password?',
  dontHaveAnAccount: "Don't have an account?",
  createHere: 'Create here',
  confirmPasswordError: 'The passwords are not matching',
  reorderCrossMarketError:
    'The order has been placed from a different market, please check the order number and go to correct market',
  signInBannerTitle: 'Sign in / Create an account',
  signInBannerDescription:
    'To track orders, view order history, and manage addresses effortlessly.',
  backToShopping: 'Back to shopping',
  addAddressLine2: 'Add address line 2',
  invalidEmail: 'Invalid email',
  invalidPhoneNumber: 'Invalid phone number',
  shipTo: 'Ship to?',
  menu: 'Menu',
  deliveringTo: 'Delivering to',
  deliveryTimeText: '1-3 days delivery',
  signInWithGoogle: 'Sign in with Google',
  comment: 'Comment',
  pc: 'pc',
  previewImageError:
    'An error occurred while trying to preview your sticker, please try again later.',
  stickerLayer: 'Sticker layer',
  getYourOrderOn: 'Get your stuff on {estimatedDelivery} to {customerPostalCode}',
  getYourOrderBetween: 'Get your stuff between {estimatedDelivery} to {customerPostalCode}',
  deliveryDetailsTitle: 'Delivery details',
  deliveryDetailsDescription: 'View when and how we deliver',
  availableDeliveryMethods: 'Available delivery method(s)',
  reliableCarrier:
    'A reliable carrier like FedEx will deliver your order straight to your home. Choose your preferred delivery option at Checkout.',
  fileTypeNotSupported: 'File type not supported',
  setYourPostalCodeToViewDeliveryOptions: 'Set your postal code to view delivery options.',
  freeShipping: 'Free shipping',
  leftToFreeShipping: 'Left to free shipping',
  shipToAnotherCountry: 'Ship to another country?',
  shipToAnotherCountryTitle: 'Ship to another country',
  shipToAnotherCountryDisclaimer:
    'Please note that shipping costs and delivery options may update when changing the country.',
  customStickerType: 'Custom',
  delete: 'Delete',
  orderReference: 'Order reference',
  giftCard: '{amount} Gift card',
  validated: 'Validated',
  bookMeeting: 'Book a meeting',
  vatNumberFormat: 'VAT number should start with country code, and be between 8 and 15 in length',
  giftCardCannotBeUsedToBuyGiftCard: 'You cannot use a gift card to buy a gift card',
  cartHasAlreadyBeenPaidFor: 'This cart has already been paid for',
  invalidShippingMethod: 'Invalid shipping method',
  stickerPackNotFound: 'Sticker pack not found',
  lineItemNotFound: 'Line item not found',
  orderNotFound: 'Order not found',
  codeAlreadyAdded: 'Code already added',
  invalidCode: 'Invalid code',
  giftCardAlreadyUsed: 'Gift card already used',
  codeNotFound: 'Code not found',
  invalidVatNumber: 'Invalid VAT number',
  catalogItemNotFound: 'Catalog item not found',
  catalogItemAlreadyInAnotherCart: 'Catalog item already in another cart',
  quantityMustBeGreaterThan0: 'Quantity must be greater than 0',
  quantityMustBeGreaterThanMinimum: 'Quantity must be greater than minimum',
  shopItemNotFound: 'Shop item not found',
  customStickerNotFound: 'Custom sticker not found',
  invalidPaymentMethod: 'Invalid payment method',
  additionDutiesAndTaxes: 'Additional duties and taxes may apply',
  paidForByGiftCards: 'This cart has been paid for by gift cards',
  remaining: 'remaining',
  missingShippingMethod: 'Select a shipping method',
  missingPaymentMethod: 'Select a payment method',
  invalidCountryOrCurrency: 'Invalid country or currency',
  invalidCustomerData: 'Please review your address and contact details',
  loading: 'Loading',
  addComment: 'Add comment',
  bundle: 'Bundle',
  customStickersBundle: 'Custom stickers bundle',
  bundleSavings: 'Bundle savings ({amount} pcs)',

  // Sticker types used for product names in cart
  die_cut: 'Die Cut',
  sheet: 'Stickers on Sheet',
  sheet_kiss_cut: 'Kiss Cut Sheet',
  hang_tag: 'Hang Tag',
  '3d_dome': 'Epoxy 3D',
  front_adhesive: 'Front Adhesive',
  heavy_duty: 'Heavy Duty',
  removable: 'Removable Sticker',
  double_sided: 'Double Sided',
  labels_on_sheet: 'Labels on Sheet',
  labels_on_roll: 'Labels on Roll',
  single_on_sheet: 'Single on Sheet',
  heat_transfer_singles: 'Heat Transfer Singles',
  wall: 'Wall Sticker',
  floor: 'Floor Sticker',
  library_design: 'Library Design',
  giftCardsPaymentMethod: 'Gift card',
};

type CommonTranslations = typeof defaultValues;

export const setCommonTranslationsContext = (commonTranslations: Partial<CommonTranslations>) => {
  const defaultedCommonTranslations = objectFromEntries(
    objectEntries(defaultValues).map(([key, value]) => [key, commonTranslations[key] || value]),
  );
  setContext<CommonTranslations>(CommonTranslationsContextKey, defaultedCommonTranslations);
};

export const getCommonTranslations = (): CommonTranslations => {
  if (!hasContext(CommonTranslationsContextKey)) {
    return defaultValues;
  }

  return getContext<CommonTranslations>(CommonTranslationsContextKey);
};
